module.exports = __webpack_public_path__ + "img/wfzs.3944a3f.png";